import React from 'react';
import { getButtonClasses } from '../../utils/styleUtils';

/**
 * Reusable Button component with consistent styling
 * 
 * @param {Object} props - Component props
 * @param {string} props.variant - Button variant (primary, secondary, small, large)
 * @param {string} props.className - Additional CSS classes
 * @param {React.ReactNode} props.children - Button content
 * @param {Function} props.onClick - Click handler
 * @param {string} props.type - Button type (button, submit, reset)
 * @param {boolean} props.disabled - Whether button is disabled
 * @param {Object} props.rest - Additional props
 */
const Button = ({ 
  variant = 'primary', 
  className = '', 
  children, 
  onClick, 
  type = 'button',
  disabled = false,
  ...rest 
}) => {
  const buttonClasses = getButtonClasses(variant, className);

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;